import React from "react";
import { useHistory } from "react-router";
import NotificationDirectIcon from "@atlaskit/icon/glyph/notification-direct";

import propOr from "ramda/src/propOr";
import andThen from "ramda/src/andThen";
import compose from "ramda/src/compose";

import Api from "../../services/Api";
import { IconButton } from "../../UI/IconButton";
import useAuth from "../../routes/login/AuthContext";
import { COLOR_DODGER_BLUE, COLOR_WHITE } from "../../constants/styles";
import { URL } from "../../constants/navigation";
import { Badge } from "../Badge";

export const Notifications = () => {
  const { push } = useHistory();
  const { getAuthToken } = useAuth();
  const [requests, setRequests] = React.useState(0);

  React.useEffect(() => {
    const handleResponse = compose((x: any[]) => setRequests(x.length), propOr([], "response"));

    const getRequests = compose(andThen(handleResponse), async () => Api.getAdminAccessRequests(await getAuthToken()));

    getRequests();
  }, []);

  const pushToAdminRequests = () => push(URL.ADMIN_ACCESS_REQUEST_CONTROL);

  return (
    <>
      <IconButton onClick={pushToAdminRequests}>
        <Badge badgeContent={requests} style={{ backgroundColor: COLOR_DODGER_BLUE, color: COLOR_WHITE }}>
          <NotificationDirectIcon label="notifications" primaryColor={COLOR_WHITE} />
        </Badge>
      </IconButton>
    </>
  );
};
